export default (state, action) => {
  switch (action.type) {
    case "Show_Sidebar_Route":
      return {
        ...state,
        sidebarRoute: action.payload,
      };
    case "TimeDelay":
      return {
        ...state,
        seconds: action.seconds,
      };
    case "Seconds_Time":
      return {
        ...state,
        seconds: action.payload.seconds,
        time: action.payload.time,
      };
    case "ShowModal":
      return {
        ...state,
        showModal: action.showModal,
      };
    case "Time":
      return {
        ...state,
        time: action.time,
      };
    case "Role": {
      return {
        ...state,
        role: action.payload,
      };
    }
    case "User_Site_File_Permission":
      return {
        ...state,
        User_Site_File_Permission: action.payload,
      };
    case "Permission":
      return {
        ...state,
        Permission: action.payload,
      };
    default:
      return state;
  }
};
